import { lazy } from 'react';

export const AsyncOldMainPageContainer = lazy(() => import(
  /* webpackChunkName: 'old_main_page' */
  './OldMainPageContainer'
));
